<template>
  <div class="page_content bookmark-list-page" v-if="permission && permission.version === '5'">

    <div class="row page-heading pg_hd">
      <div class="col-12 input module_heading">
        <div class="header-left">
          <span class="module_icon icon-bookmark"></span>
          <h1 class="head_txt module_type_name ace_sec_hd" role="heading" aria-level="1">
            My Bookmarks
          </h1>
          <div class="bookmarks-filters">
            <b-button @click.stop="toggleFiltersDropDown" id="bookmarksTypeDropDown" class="form-field bookmark-type-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">Select Bookmark Type</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="bookmarksFiltersPopup" class="explore_filter_container"></div>
            <b-popover target="bookmarksTypeDropDown" :show.sync="showFiltersDropDown" container="bookmarksFiltersPopup" triggers="blur">
              <div class="field-row" v-for="typeValue in typeArray" :key="'filter-' + typeValue">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" :id="'bookmark-filter-' + typeValue" :value="typeValue" v-model="typeFilterDraft" @click.stop @input.stop>
                  <label class="form-check-label" :for="'bookmark-filter-' + typeValue">{{ typeValue }}</label>
                </div>
              </div>
              <b-btn @click="filtersOkClicked" class="range-button">ok</b-btn>
            </b-popover>
          </div>
        </div>
        <div class="toolbar-right">
          <div class="out-of-total-item ace_sec_txt">
            <div>{{ filteredBookmarks.length }} bookmarks</div>
          </div>
          <div class="number-of-item ace_sec_txt">
            <b-dropdown id="bookmarksSizeDropdown" :text="'' + pageSize" aria-label="number of item">
              <template v-for="(option, index) in sizeOptions">
                <b-dropdown-divider v-if="index > 0" :key="'divider-' + option"></b-dropdown-divider>
                <b-dropdown-item :key="'size-' + option" @click="changeSize(option)">{{ option }}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
          <div class="pagination btn_container pagination_sty3">
            <button type="button" class="btn btn_trans" :disabled="firstPage" @click="prev" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="current-page ace_sec_txt">{{ page + 1 }}</span>
            <button type="button" class="btn btn_trans" :disabled="lastPage" @click="next" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>

          <div class="search-box-container">
            <input type="text" class="input-search" placeholder="type to narrow results" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" aria-label="type to narrow results">
            <button class="btn btn_srh" @click="searchButtonClicked" aria-label="go">
              <span class="ic_srh ic_search"></span>
            </button>
            <button id="bookmarksSortByDropDown" type="button" @click="toggleSortByDropDown" class="sort-by ace_sec">
              <span class="ic2_sort2 sort-by-icon"></span>
              <span class="txt_srt">sort</span>
            </button>
            <div id="bookmarksSortPopup" class="sort_by_popover"></div>
          </div>
          <b-popover target="bookmarksSortByDropDown" :show.sync="showSortByDropDown" container="bookmarksSortPopup" triggers="blur">
            <div class="header-content-row">
              <span class="title">Sort by</span>
            </div>
            <template v-for="sort in sorts">
              <div class="field-row" :key="sort.name">
                <div class="form-check">
                  <input type="radio" class="form-check-input" :id="'bookmark-sort-' + sort.name" v-model="selectedSortName" :value="sort.name">
                  <label class="form-check-label" :for="'bookmark-sort-' + sort.name">{{ sort.name }}</label>
                </div>
              </div>
            </template>
            <b-btn @click="sortOkClicked" class="range-button">ok</b-btn>
          </b-popover>
        </div>
      </div>
    </div>

    <div class="course-management-section">
      <div class="bookmarks-list-container">
        <div v-if="pagedBookmarks && pagedBookmarks.length > 0" class="bookmarks-list">
          <div
            class="bookmark-row"
            v-for="bookmark in pagedBookmarks"
            :key="bookmark.uuid">
            <div class="bookmark-row-main">
              <div class="bookmark-name">
                <span class="ic_container">
                  <span class="ic icon-briefcase" v-if="bookmark.entityType==='job'"></span>
                  <span class="ic ico-degreeProgram" v-if="bookmark.entityType==='programguide'"></span>
                  <span class="ic ico-career" v-if="bookmark.entityType==='career'"></span>
                  <span class="ic ico-employer" v-if="bookmark.entityType==='employer'"></span>
                </span>
                <a href="javascript:void(0);" class="bookmark-title ace_sec_txt" @click="goToBookmark(bookmark)">
                  {{ bookmark.entityTitle }}
                  <span v-if="bookmark.type && bookmark.type === 'CAREER_INTEREST'">(Career Interest)</span>
                  <span v-if="bookmark.type && bookmark.type === 'PROGRAM_INTEREST'">(Program Interest)</span>
                </a>
              </div>
              <div class="bookmark-type ace_sec_txt">{{ getEntityTypeValue(bookmark.entityType) }}</div>
              <button
                type="button"
                class="bookmark-delete-btn"
                aria-label="delete"
                @click="showDeleteBookmarkConfirmBox(bookmark)">
                <span class="icon-bin"></span>
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="isBookmarksLoaded" class="no-result ace_sec_txt">No Results Found</div>
      </div>
    </div>

    <div>
        <b-modal class="delete-folder-popup" ref="bookmarkModal" :title="'Please Confirm!'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
            <div>
                <span>{{ bookmarkDeleteMessage }}</span>
            </div>
          <div slot="modal-header" class="popover-header">
            <div class="popup-heading">Please Confirm!</div>
            <button class="btn_close" aria-label="close" @click="hideDeleteConfirmBox">
                <span class="ic-close"></span>
            </button>
          </div>
          <div slot="modal-footer" class="w-100">
              <b-button @click="deleteBookmarkAndHideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
              <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
          </div>
        </b-modal>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import '../../../assets/module/css/user/userList.min.css'
import '../../../assets/module/sass/course/courseList.scss'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'bookmarks',
  data () {
    return {
      pageSize: 20,
      sizeOptions: [20, 50, 100],
      firstPage: true,
      lastPage: true,
      page: 0,
      bookmarks: [],
      isBookmarksLoaded: false,
      searchTerms: '',
      appliedSearch: '',
      showFiltersDropDown: false,
      showSortByDropDown: false,
      typeFilterDraft: [],
      typeFilterSelected: [],
      selectedSortName: 'Name',
      sorts: [
        { name: 'Name' },
        { name: 'Type' }
      ],
      typeArray: ['Career', 'Job', 'Program', 'Stream', 'Catalogs', 'Employer'],
      bookmarkDeleteMessage: '',
      bookmarkToBeDeleted: {}
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.loadBookmarkList()
      }, 500)
    })
  },
  methods: {
    ...mapActions([
      'loadBookmarks',
      'loadDeleteBookmark',
      'loadPermission',
      'loadCareerUsingUuid',
      'loadProgramGuideUsingUuid'
    ]),
    loadBookmarkList () {
      this.loadBookmarks({page: 0, count: 1000, name: ''}).then(result => {
        this.bookmarks = this.normalizeBookmarks(result)
        this.page = 0
        this.updatePaging()
        this.isBookmarksLoaded = true
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      })
    },
    normalizeBookmarks (result) {
      if (!result) {
        return []
      }
      if (result.length > 0 && result[0] && result[0].content) {
        return result[0].content || []
      }
      if (result.content) {
        return result.content || []
      }
      if (result.length >= 0 && result[0] && result[0].entityTitle) {
        return result
      }
      if (result.length >= 0) {
        return result
      }
      return []
    },
    bookmarkTypeLabel (bookmark) {
      if (!bookmark) {
        return ''
      }
      return this.getEntityTypeValue(bookmark.entityType)
    },
    updatePaging () {
      let totalPages = Math.ceil(this.filteredBookmarks.length / this.pageSize)
      if (totalPages < 1) {
        totalPages = 1
      }
      if (this.page > totalPages - 1) {
        this.page = totalPages - 1
      }
      this.firstPage = this.page <= 0
      this.lastPage = this.page >= totalPages - 1
    },
    searchButtonClicked () {
      this.appliedSearch = this.searchTerms
      this.resetPage()
    },
    toggleFiltersDropDown () {
      this.typeFilterDraft = this.typeFilterSelected.slice()
      this.showFiltersDropDown = !this.showFiltersDropDown
    },
    filtersOkClicked () {
      this.typeFilterSelected = this.typeFilterDraft.slice()
      this.showFiltersDropDown = false
      this.resetPage()
    },
    toggleSortByDropDown () {
      this.showSortByDropDown = !this.showSortByDropDown
    },
    sortOkClicked () {
      this.showSortByDropDown = false
      this.resetPage()
    },
    changeSize (option) {
      this.pageSize = option
      this.resetPage()
    },
    sortBookmarks (list) {
      let sorted = list.slice()
      let name = this.selectedSortName
      sorted.sort((a, b) => {
        if (name === 'Type') {
          return (this.bookmarkTypeLabel(a) || '').localeCompare(this.bookmarkTypeLabel(b) || '')
        }
        return (a.entityTitle || '').localeCompare(b.entityTitle || '')
      })
      return sorted
    },
    resetPage () {
      this.page = 0
      this.updatePaging()
    },
    prev () {
      if (this.firstPage) {
        return
      }
      this.page -= 1
      this.updatePaging()
    },
    next () {
      if (this.lastPage) {
        return
      }
      this.page += 1
      this.updatePaging()
    },
    showDeleteBookmarkConfirmBox (bookmark) {
      this.bookmarkToBeDeleted = bookmark
      this.$refs.bookmarkModal.show()
      if (bookmark.type && bookmark.type === 'CAREER_INTEREST') {
        this.bookmarkDeleteMessage = 'You had selected ' + bookmark.entityTitle + ' as your career of interest!  Deleting this bookmark will remove this from your interest list and change the recommendations you see.  Do you still want to delete it?'
      } else if (bookmark.type && bookmark.type === 'PROGRAM_INTEREST') {
        this.bookmarkDeleteMessage = 'You had selected ' + bookmark.entityTitle + ' as your program of interest!  Deleting this bookmark will remove this from your interest list and change the recommendations you see.  Do you still want to delete it?'
      } else {
        this.bookmarkDeleteMessage = 'Are you sure you would like to delete this bookmark?'
      }
    },
    deleteBookmarkAndHideDeleteConfirmBox () {
      this.$refs.bookmarkModal.hide()
      this.deleteBookmarkClicked()
    },
    deleteBookmarkClicked () {
      if (this.bookmarkToBeDeleted && this.bookmarkToBeDeleted.uuid) {
        this.loadDeleteBookmark(this.bookmarkToBeDeleted.uuid).then(res => {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully deleted \'' + this.bookmarkToBeDeleted.entityTitle + '\''
          })
          this.loadBookmarkList()
        })
      }
    },
    hideDeleteConfirmBox () {
      this.bookmarkToBeDeleted = {}
      this.$refs.bookmarkModal.hide()
    },
    goToBookmark (bookmark) {
      if (bookmark.entityType === 'career') {
        this.$refs.loadingModal.show()
        this.loadCareerUsingUuid(bookmark.entityUuid).then(career => {
          this.$refs.loadingModal.hide()
          if (career.code) {
            let routerParams = { code: career.pragyaSoc, returnTo: 'bookmarks' }
            return this.$router.push({ name: 'careerDetail', params: routerParams })
          }
        })
      } else if (bookmark.entityType === 'programguide') {
        this.$refs.loadingModal.show()
        this.loadProgramGuideUsingUuid(bookmark.entityUuid).then(programGuide => {
          this.$refs.loadingModal.hide()
          if (programGuide && programGuide.cipCode) {
            let routerParams = { cipCode: programGuide.cipCode, programGuideCode: programGuide.code, type: programGuide.type, returnTo: 'bookmarks' }
            return this.$router.push({ name: 'programGuideIntroduction', params: routerParams })
          } else {
            return this.$notify({
              group: 'notify',
              type: 'warn',
              title: '',
              text: 'The selected Program Guide has no associated cip code. Unable to render page.'
            })
          }
        })
      } else if (bookmark.entityType === 'job') {
        return this.$router.push({ name: 'jobHome', params: { uuid: bookmark.entityUuid } })
      } else if (bookmark.entityType === 'employer') {
        return this.$router.push({ name: 'employerDetails', params: { uuid: bookmark.entityUuid } })
      } else if (bookmark.entityType === 'stream') {
        return this.$router.push({ name: 'streamTime', params: { uuid: bookmark.entityUuid } })
      } else if (bookmark.entityType === 'catalogs') {
        return this.$router.push({ name: 'catalogDetail', params: { uuid: bookmark.entityUuid, loadDataFromServer: true } })
      }
    },
    getEntityTypeValue (entityType) {
      if (entityType === 'programguide') {
        return 'Program'
      }
      if (entityType === 'career') {
        return 'Career'
      }
      if (entityType === 'job') {
        return 'Job'
      }
      if (entityType === 'employer') {
        return 'Employer'
      }
      if (entityType === 'stream') {
        return 'Stream'
      }
      if (entityType === 'catalogs') {
        return 'Catalogs'
      }
      return entityType
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission
    }),
    filteredBookmarks () {
      let list = this.bookmarks || []
      if (this.appliedSearch) {
        let term = this.appliedSearch.toLowerCase()
        list = list.filter((bookmark) => {
          let title = bookmark.entityTitle || ''
          let type = this.bookmarkTypeLabel(bookmark) || ''
          return title.toLowerCase().indexOf(term) !== -1 || type.toLowerCase().indexOf(term) !== -1
        })
      }
      if (this.typeFilterSelected && this.typeFilterSelected.length > 0) {
        list = list.filter((bookmark) => {
          let label = this.bookmarkTypeLabel(bookmark)
          return this.typeFilterSelected.indexOf(label) !== -1
        })
      }
      return this.sortBookmarks(list)
    },
    pagedBookmarks () {
      let start = this.page * this.pageSize
      return this.filteredBookmarks.slice(start, start + this.pageSize)
    }
  }
}
</script>

<style scoped>
  .bookmark-list-page {
    height: calc(100vh - 134px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .page-heading.pg_hd {
    flex: 0 0 auto;
    margin-bottom: 0;
    position: relative;
    z-index: 5;
    background: #fff;
  }

  .page-heading.pg_hd .module_heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    width: 100%;
    margin-top: 0;
    padding-right: 20px;
  }

  .header-left {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 0 1 auto;
    flex-wrap: nowrap;
  }

  .header-left .module_icon {
    float: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    font-size: 28px;
    line-height: 28px;
    margin: 0 8px 0 0 !important;
  }

  .page-heading.pg_hd .module_heading .head_txt {
    width: auto;
    max-width: none;
    min-width: 0;
    float: none;
    display: block;
    margin: 0;
    padding: 0;
    line-height: 28px;
    /*overflow: hidden;*/
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin-left: 16px;
    flex: 0 0 auto;
  }

  .bookmarks-filters {
    position: relative;
    margin-left: 12px;
    margin-right: 0;
    flex-shrink: 0;
  }

  .bookmarks-filters .form-field {
    padding: 0 10px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: none;
    color: #000 !important;
  }

  .bookmarks-filters .form-field:hover,
  .bookmarks-filters .form-field:focus,
  .bookmarks-filters .form-field:active {
    color: #000 !important;
  }

  .bookmarks-filters .form-field label,
  .bookmarks-filters .form-field .txt_sh,
  .bookmarks-filters .form-field {
    color: #000 !important;
  }
  .bookmarks-filters .form-field label {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-bottom: 0;
  }

  .bookmarks-filters .bookmark-type-filter,
  .bookmarks-filters .bookmark-type-filter:hover,
  .bookmarks-filters .bookmark-type-filter:focus {
    background: #7ad8f0 !important;
    color: #000 !important;
  }

  .bookmarks-filters .explore_filter_container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 0;
  }

  .toolbar-right .out-of-total-item {
    margin-right: 10px;
    white-space: nowrap;
    font-size: 16px;
  }

  .toolbar-right .number-of-item {
    margin-right: 10px;
  }
  .toolbar-right .number-of-item >>> .dropdown-toggle {
    height: 32px;
    padding: 0 12px;
    background-color: #8f8f8f;
    border: none;
    color: #fff;
  }

  .toolbar-right .pagination {
    display: flex;
    align-items: center;
    margin-right: 12px;
  }

  .toolbar-right .pagination .fa {
    cursor: pointer;
    padding: 0 6px;
  }

  .toolbar-right .pagination .fa.disabled {
    opacity: 0.35;
    cursor: default;
    pointer-events: none;
  }

  .toolbar-right .search-box-container {
    display: flex;
    align-items: center;
    width: auto;
    float: none;
  }

  .toolbar-right .sort-by {
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    border: solid 1px #e6e6e6;
    padding: 4px 8px;
    border-radius: 3px;
    background: #f5f5f5;
  }

  .toolbar-right .sort-by .ic_srt {
    display: block;
    font-size: 20px;
    margin-right: 4px;
  }

  .toolbar-right .sort-by .txt_srt {
    display: inline-block;
  }

  .course-management-section {
    flex: 1 1 auto;
    min-height: 0;
    margin-top: 0;
    padding: 0 20px 16px;
    overflow: hidden;
  }

  .bookmarks-list-container {
    width: 100%;
    height: 100%;
    min-width: 0;
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .bookmarks-list-container::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  .bookmark-row {
    width: 100%;
    min-width: 0;
    overflow: hidden;
    border-bottom: 1px solid #e6e6e6;
  }

  .bookmark-row-main {
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) minmax(0, 0.8fr) 40px;
    align-items: center;
    column-gap: 24px;
    min-height: 64px;
    width: 100%;
    min-width: 0;
    padding: 14px 8px 14px 4px;
  }

  .bookmark-name {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .bookmark-name .ic_container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    margin-right: 8px;
    line-height: 0;
  }

  .bookmark-name .ic {
    font-size: 22px !important;
    line-height: 1;
    display: block;
  }

  .bookmark-title {
    display: block;
    flex: 1 1 auto;
    min-width: 0;
    font-size: 16px;
    font-weight: 500;
    color: #4a4a4a;
    line-height: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
    cursor: pointer;
  }

  .bookmark-title:hover {
    text-decoration: underline;
  }

  .bookmark-type {
    font-size: 15px;
    color: #6a6a6a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bookmark-delete-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    background: transparent;
    color: #8a8a8a;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    justify-self: end;
    box-shadow: none;
  }

  .bookmark-delete-btn .icon-bin {
    font-size: 20px;
  }

  .bookmark-delete-btn:hover,
  .bookmark-delete-btn:focus {
    color: #c45c5c;
    outline: none;
  }

  .no-result {
    text-align: center;
    padding: 32px 8px;
  }

  @media (max-width: 900px) {
    .bookmark-row-main {
      grid-template-columns: minmax(0, 1fr) 40px;
      row-gap: 8px;
    }

    .bookmark-name {
      grid-column: 1 / 2;
    }

    .bookmark-delete-btn {
      grid-column: 2 / 3;
      grid-row: 1 / 2;
    }

    .bookmark-type {
      grid-column: 1 / 2;
    }
  }
</style>

<style>
  .page_content_container:has(.bookmark-list-page) {
    overflow: hidden;
    padding-bottom: 0;
  }

  .bookmark-list-page .sort_by_popover .popover,
  .bookmark-list-page .explore_filter_container .popover {
    transform: none !important;
    top: 32px !important;
    margin: 0 !important;
    min-width: 240px;
  }

  .bookmark-list-page .sort_by_popover .popover {
    top: 2px !important;
    left: auto !important;
    right: 0 !important;
  }

  .bookmark-list-page .explore_filter_container .popover {
    left: 0 !important;
    right: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/BookmarkList.vue